export default "__VITE_ASSET__CawjCty1__"